import axios from '@/axios.js'

export default {
    getContactPhones: async (appUuid) => {
        try {
            const response = await axios.editorapi.get(`v4/contact-phones/apps/${appUuid}`)
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    getContactPhoneTypes: async () => {
        try {
            const response = await axios.editorapi.get(`v4/contact-phones/types`)
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    createContactPhone: async (appUuid, payload) => {
        try {
            const response = await axios.editorapi.post(`v4/contact-phones/apps/${appUuid}`, payload)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },
    saveContactPhone: async (appUuid, contactphoneUuid, payload) => {
        try {
            const response = await axios.editorapi.patch(`v4/contact-phones/apps/${appUuid}/${contactphoneUuid}`, payload)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },
    deleteContactPhone: async (appUuid, contactphoneUuid) => {
        try {
            const response = await axios.editorapi.delete(`v4/contact-phones/apps/${appUuid}/${contactphoneUuid}`)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },
    sortContactPhones: async (appUuid, contactPhonesOrdered) => {
        try {
            const response = await axios.editorapi.patch(`v4/contact-phones/apps/${appUuid}`, { 'sorted_contact_phones': contactPhonesOrdered })
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    }
}